var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"width":"100%"}},[_c('v-main',[_c('div',{staticClass:"d-flex flex-grow-1 align-center justify-center fill-height"},[_c('HelpTooltip',[_vm._v(_vm._s(_vm.$t("toolTipExample")))])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }